
import BaseEvent from "./BaseEvent";

export default class MapEvent extends BaseEvent{

    static CHANGE:string = "change";
    static USE_CHOSEN_LOCATION:string = "useChosenLocation";

    static UPDATE_MAP_TO_ADDRESS:string = "updateToChange";
    static TOGGLE_FULLSCREEN:string = "mapToggleFullscreen";
    

}